import { Dispatch, SetStateAction, useEffect, useState  } from "react";
import { IFilters } from "../FinancialTransactionsReport";
import s from './index.module.css'
import { directionOrdersApi } from "@/api";
import Select from "@UI/New/Select";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";
import { useAddAlert } from "@/hooks/useAddAlert";

interface FinancialTransactionsReportFiltersProps {
  filters: IFilters;
  setFilters: Dispatch<SetStateAction<IFilters>>;
  userId: number;
}
interface IOption {
  value: string | number;
  label: string;
}

export const FinancialTransactionsReportFilters = ({filters, setFilters, userId}: FinancialTransactionsReportFiltersProps) => {
    const addAlert = useAddAlert()
    const [options, setOptions] = useState<IOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
        if(!userId) {
            addAlert({title: 'Ошибка', text: 'Курсы для фильтра не загружены, не передан id учащегося', type: 'error'})
            return
        };
        setLoading(true)
        directionOrdersApi.getHistoryForSelect({id: userId})
            .then(({data})=>{
                if(data?.status === 'success'){
                    setOptions(data?.data)
                }
                else{
                    setOptions([])
                    addAlert({title: 'Ошибка', text: 'При загрузке курсов для фильтра произошла ошибка', type: 'error'})
                }
            })
            .finally(() => setLoading(false))
    }, [userId])

    const fieldsAllCourses = {
        loading,
        showSearch: true,
        allowClear: true,
        filterOption: filterOptionsByLabel,
        onChange: (e: number | string) => setFilters(prev => ({...prev, directionId: e || null})),
        options: options,
        value: filters.directionId,
        placeholder: 'Выберите курс',
        notFoundContent: "Курсы не найдены" 
    };
    const statusFields = {
        allowClear: true,
        onChange: (status: string) =>
            setFilters((prev) => ({ ...prev, status: status || null })),
        options: [
            { value: 'paid', label: 'Оплачено' },
            { value: 'withdrawn', label: 'Списано' },
            { value: 'refunded', label: 'Возвращено' },
        ],
        value: filters.status,
        placeholder: 'Выберите статус',
    };
    
    return (
        <div className={s.wrapper}>
            <Select
                wrapperClassName={s.wrapperSelect} 
                className={s.select} 
                fields={fieldsAllCourses} 
            />
            <Select
                wrapperClassName={s.wrapperSelect}
                className={s.select}
                fields={statusFields}
            />
        </div>
    )
}
